let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9k6W3")).then(() => parcelRequire('29Rfx'));